import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const ctaObjectsUrl = `${process.env.PUBLIC_URL ?? ''}/images/home/cta-objects.png`;

const ctaObjectsMaskStyle: React.CSSProperties = {
  WebkitMaskImage: `url("${ctaObjectsUrl}")`,
  maskImage: `url("${ctaObjectsUrl}")`,
};

export interface SiteClosingCtaProps {
  titleLines: readonly string[];
  subtitle: string;
  cta?: { label: string; to: string };
  ctaAction?: React.ReactNode;
  titleId?: string;
}

export const SiteClosingCta: React.FC<SiteClosingCtaProps> = ({
  titleLines,
  subtitle,
  cta,
  ctaAction,
  titleId = 'io-site-closing-title',
}) => (
  <section className="io-home-closing" aria-labelledby={titleId}>
    <div className="io-home-closing__bg" aria-hidden />
    <div className="io-home-closing__objects" aria-hidden>
      <div className="io-home-closing__objects-side io-home-closing__objects-side--left">
        <div
          className="io-home-closing__objects-fig io-home-closing__objects-fig--left"
          style={ctaObjectsMaskStyle}
        />
      </div>
      <div className="io-home-closing__objects-side io-home-closing__objects-side--right">
        <div
          className="io-home-closing__objects-fig io-home-closing__objects-fig--right"
          style={ctaObjectsMaskStyle}
        />
      </div>
    </div>
    <div className="io-home-closing__inner">
      <div className="io-home-closing__copy">
        <h2 id={titleId} className="io-home-closing__title">
          {titleLines.map((line, i) => (
            <span key={i} className="io-home-closing__title-line">
              {line}
            </span>
          ))}
        </h2>
        <p className="io-home-closing__subtitle">{subtitle}</p>
      </div>
      {ctaAction ??
        (cta ? (
          <Link to={cta.to} className="io-home-closing__cta">
            {cta.label}
            <ArrowRight className="io-home-closing__cta-icon" size={20} strokeWidth={2} aria-hidden />
          </Link>
        ) : null)}
    </div>
  </section>
);
